import { useTranslation } from "react-i18next";
import { routeLabel } from "../../lib/trip-route";
import type { Trip } from "../../types";
import { useTripActions } from "../../state/trip-context";
import { formatTripDates } from "./trip-date";

import { Icon } from "@majourneys/icons";
interface TripOverviewProps {
  readonly trips: readonly Trip[];
  readonly onCreate: () => void;
}

export function TripOverview({ trips, onCreate }: TripOverviewProps) {
  const { t, i18n } = useTranslation();
  const { setActiveTrip, deleteTrip } = useTripActions();

  return (
    <div className="mj-trip-glass-shell">
      <header className="mj-trip-ov-header">
        <div>
          <h2>{t("trip.your_trips")}</h2>
          <p>
            {t("trip.your_trips_subtitle")}
          </p>
        </div>
        <button
          type="button"
          className="mj-trip-ov-header__cta"
          onClick={onCreate}
        >
          <Icon name="ri-add-line" aria-hidden="true" />
          {t("trip.new_trip")}
        </button>
      </header>
      <div className="mj-trip-ov-grid">
        {trips.map((trip) => (
          <article key={trip.id} className="mj-trip-ov-card">
            <button
              type="button"
              className="mj-trip-ov-card__delete"
              onClick={(event) => {
                event.stopPropagation();
                if (
                  confirm(t("trip.confirm_delete", { name: trip.name })) === true
                ) {
                  deleteTrip(trip.id);
                }
              }}
              aria-label={t("trip.delete_named", { name: trip.name })}
            >
              <Icon name="ri-delete-bin-line" aria-hidden="true" />
            </button>
            <button
              type="button"
              className="mj-trip-ov-card__open"
              onClick={() => setActiveTrip(trip.id)}
            >
              <span className="mj-trip-ov-card__placeholder" aria-hidden="true">
                {trip.city.slice(0, 1).toUpperCase()}
              </span>
              <span className="mj-trip-ov-card__overlay" aria-hidden="true" />
              <span className="mj-trip-ov-card__body">
                <strong>{trip.name}</strong>
                <span>
                  {/* Same line as the phone's trip card: city, dates, days. */}
                  {[
                    routeLabel(trip, (slug) => slug.charAt(0).toUpperCase() + slug.slice(1), i18n.dir(i18n.language) === "rtl"),
                    formatTripDates(trip, i18n.language, (start, end) => t("trip.when.range", { start, end })),
                    t("trip.day_count", { count: trip.days.length }),
                  ]
                    .filter(Boolean)
                    .join(" · ")}
                </span>
                <small>
                  <Icon name="ri-draft-line" aria-hidden="true" />
                  {t("trip.draft")}
                </small>
              </span>
            </button>
          </article>
        ))}
      </div>
    </div>
  );
}
